import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { WorkorderService } from '../../../../services/workorder.service';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ViewWoDetailsComponent } from '../../../popups/view-wo-details/view-wo-details.component';
import { ViewDetailModalComponent } from '../../../popups/view-detail-modal/view-detail-modal.component';

@Component({
  selector: 'wo-search',
  templateUrl: './wo-search.component.html',
  styleUrls: ['./wo-search.component.scss']
})
export class WoSearchComponent implements OnInit {

  advance_search = false;
  serviceType: any;
  loading: boolean;
  subServiceType: any;
  woStatus: any;
  workOderSearchForm: UntypedFormGroup;
  bdStates: any;
  bdCities: any;
  breakdownCity: any;
  vendorList: any;
  providerName: any;
  getWorkOrder: any;
  getWObyEvent: any;
  setWorkOrderByEvent: any;
  dataNotFound: boolean;

  constructor(
    public dialogRef: MatDialogRef<WoSearchComponent>,
    private woService: WorkorderService,
    private formBuilder: UntypedFormBuilder,
    private datePipe: DatePipe,
    public dialog: MatDialog
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.getServiceType();
    this.vendorList = this.woService.getVendorRecords();
    if (!this.vendorList) {
      this.vendorSearch();
    }
    this.workOderSearchForm = this.formBuilder.group({
      woNumber: [''],
      externalAssetId: [''],
      referenceNumber: [''],
      serviceType: [''],
      subServiceType: [''],
      woStatus: [''],
      poNumber: [''],
      startDate: [''],
      endDate: [''],
      shipToName: [''],
      breakdownState: [''],
      vendorName: ['']
    });
  }

  getServiceType() {
    this.woService.getWOServiceTypes().subscribe(res => {
      this.serviceType = res.body;
      this.getCompanyStates();
    });
  }

  getSubServices(serviceID) {
    this.loading = true;
    if (serviceID.value != undefined) {
      this.woService.getWOSubServiceTypes(serviceID.value).subscribe(res => {
        this.subServiceType = res.body;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  }

  getWoStatuses() {
    this.woService.getWoStatuses().subscribe(res => {
      this.woStatus = res.body;
    });
  }

  getCompanyStates() {
    this.woService.getCompanyStates().subscribe(res => {
      this.bdStates = res;
      this.getWoStatuses();
    });
  }

  searchCity(city) {
    if (city != undefined) {
      this.loading = true;
      this.woService.getBreakdownCity(city).subscribe(res => {
        this.bdCities = res.body;
        this.loading = false;
      });
    }
  }

  vendorSearch() {
    this.loading = true;
    this.woService.getVendorList().subscribe(res => {
      this.vendorList = res;
      this.woService.setVendorRecords(this.vendorList);
      this.loading = false;
    });
  }

  advanceSearch(event) {
    this.advance_search = event.checked == true ? true : false;
    this.breakdownCity = "";
    this.workOderSearchForm.reset();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  searchWorkOrder() {
    var woNumber = !this.workOderSearchForm.controls.woNumber.value ? 0 : this.workOderSearchForm.controls.woNumber.value;
    this.loading = true;
    var woFilter = sessionStorage.getItem('legacyCustomerKeyId');
    var woFilterType = 'Customer';
    var woExternalAssetId = !this.workOderSearchForm.controls.externalAssetId.value ? 0 : this.workOderSearchForm.controls.externalAssetId.value;
    var woReferenceNumber = !this.workOderSearchForm.controls.referenceNumber.value ? 0 : this.workOderSearchForm.controls.referenceNumber.value;
    var woServiceType = !this.workOderSearchForm.controls.serviceType.value ? 0 : this.workOderSearchForm.controls.serviceType.value;
    var woSubServiceType = !this.workOderSearchForm.controls.subServiceType.value ? 0 : this.workOderSearchForm.controls.subServiceType.value;
    var woSearchWOStatus = !this.workOderSearchForm.controls.woStatus.value ? 0 : this.workOderSearchForm.controls.woStatus.value;
    var woStartDate = this.workOderSearchForm.controls.startDate.value ? this.datePipe.transform(this.workOderSearchForm.controls.startDate.value, "yyyy-MM-dd") : 0
    var woEndDate = this.workOderSearchForm.controls.endDate.value ? this.datePipe.transform(this.workOderSearchForm.controls.endDate.value, "yyyy-MM-dd") : 0;
    var woPONumber = !this.workOderSearchForm.controls.poNumber.value ? 0 : this.workOderSearchForm.controls.poNumber.value;
    var woVendorName = !this.workOderSearchForm.controls.vendorName.value ? 0 : this.workOderSearchForm.controls.vendorName.value;
    var woBreakdownCity = !this.breakdownCity ? 0 : this.breakdownCity;
    var woBreakdownState = !this.workOderSearchForm.controls.breakdownState.value ? 0 : this.workOderSearchForm.controls.breakdownState.value;
    var woSearchShipToName = !this.workOderSearchForm.controls.shipToName.value ? 0 : this.workOderSearchForm.controls.shipToName.value;
    var VendorArr;
    var VendorKey = 0;
    if (woVendorName != 0) {
      VendorArr = woVendorName.split('-');
      VendorKey = VendorArr[0];
    }
    this.getWorkOrder = {
      'filtervalue': woFilter,
      'subCustomerId': sessionStorage.getItem('ersSubcustomerId'),
      'locationId': sessionStorage.getItem('ersLocationId'),
      'divisionId': sessionStorage.getItem('ersDivisionId'),
      'filterType': woFilterType,
      'woKey': woNumber,
      'externalAssetId': woExternalAssetId,
      'referenceNumber': woReferenceNumber,
      'woServiceType': woServiceType,
      'woSubServiceType': woSubServiceType,
      'woStatus': woSearchWOStatus,
      'woStartDate': woStartDate,
      'woEndDate': woEndDate,
      'poNumber': woPONumber,
      'providerKey': VendorKey,
      'breakdownCity': woBreakdownCity,
      'breakdownState': woBreakdownState,
      'shipToName': woSearchShipToName,
    }
    this.woService.getWOsFromWOSearch(this.getWorkOrder).subscribe(res => {
      this.getWorkOrder = res.body;
      this.dataNotFound = this.getWorkOrder.length < 1 ? true : false;
      this.loading = false;
    });
  }

  getChangeEventStatus() {
    this.loading = true;
    var woKey = !this.workOderSearchForm.controls.woNumber.value ? 0 : this.workOderSearchForm.controls.woNumber.value;
    this.getWObyEvent = {
      'customerKey': sessionStorage.getItem('legacyCustomerKeyId'),
      'subCustomerKey': 0,
      'divisionid': 0,
      'locationId': 0,
      'woKey': woKey
    }
    this.woService.getWorkOrdersForEventChange(this.getWObyEvent).subscribe(res => {
      this.setWorkOrderByEvent = res.body;
      if (this.setWorkOrderByEvent.length > 0) {
        this.openWOByEvent(this.setWorkOrderByEvent);
        this.loading = false;
      } else {
        this.dataNotFound = true;
        this.loading = false;
      }
    });
  }

  openWOByEvent(setWObyEvent):
    void {
    this.dialog.open(ViewWoDetailsComponent, {
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      width: '85%',
      data: { data: setWObyEvent }
    });
  }

  public viewDetails(woNumber): void {
    this.dialog.open(ViewDetailModalComponent, {
      height: 'auto',
      maxHeight: '90%',
      width: '90%',
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      data: { 'woNumber': woNumber }
    });
  }
}
